/*
 * Un Amore Così — story-page motion.
 * IntersectionObserver only: reveal-on-enter fires once, then unobserves.
 * No scroll listeners, no rAF scroll loops, no animation libraries.
 * prefers-reduced-motion: reduce shows everything immediately, no observer.
 * Guarded so it initializes once even if several sections load it.
 */
(function () {
  if (window.__uacStoryMotion) return;
  window.__uacStoryMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function ensureObserver() {
    if (io || reduce || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
  }

  function scan(root) {
    root = root || document;

    // Hero scale-in on load.
    root.querySelectorAll('[data-uac-hero]').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-in'); });
    });

    var reveals = root.querySelectorAll('.uac-rv');

    // Reduced motion or no IO support: reveal immediately, observe nothing.
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    ensureObserver();
    reveals.forEach(function (el) {
      if (el.dataset.uacObserved) return;
      el.dataset.uacObserved = '1';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Theme editor: re-scan a section when it is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
